<template>
<div>
    <v-text-field
        :label="label + ' Line 1'"
        v-model="address.address_line1"
        v-on:input="onChange"
        :rules="[rules.required]"
        autocomplete="address-line1"
    />

    <v-text-field
        :label="label + ' Line 2'"
        v-model="address.address_line2"
        v-on:input="onChange"
        autocomplete="address-line2"
    />

    <v-text-field
        :label="label + ' Line 3'"
        v-model="address.address_line3"
        v-on:input="onChange"
        autocomplete="address-line3"
    />

    <div class="three_container">
        
        <div class="city">
            <v-text-field
                label="City"
                v-model="address.city"
                v-on:input="onChange"
                :rules="[rules.required]"
                autocomplete="address-level2"
            />
        </div>

        <div class="state">
            <v-text-field
                label="State"
                v-model="address.state"
                v-on:input="onChange"
                :rules="[rules.required, rules.state]"
                autocomplete="address-level1"
            />
        </div>

        <div class="zip">
            <v-text-field
                label="Zip"
                v-model="address.postal_code"
                v-on:input="onChange"
                :rules="[rules.required, rules.zip]"
                autocomplete="postal-code"
            />
        </div>

    </div>

    <v-text-field
        label="Country Code"
        v-model="address.country"
        v-on:input="onChange"
        :rules="[rules.required, rules.country]"
        autocomplete="country"
    />

</div>
</template>

<script>

const _ = require('lodash');

export default {
    
    props: {
        label: {
            type: String,
            default: function() { return 'Address'; },
        },
        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    data() {
        return {
            address : {
                address_line1 : null,
                address_line2 : null,
                address_line3 : null,
                city: null,
                state: null,
                postal_code: null,
                country: 'US'
            },

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true; },
                state: (value) => { if ( value == null || value.trim().length < 2 ) return 'Two letter minimum'; return true;  },
                country: (value) => { if ( value == null || value.trim().length < 2 ) return 'Three letter minimum'; return true; },
                zip: (value) => { if ( value == null || value.trim().length < 5 ) return 'Five letter minimum'; return true; },
            },
        }
    },

    mounted () {
        this.setAddress(this.value);
    },

    methods: {
        setAddress(address) {
            
            if ( address == null )
            {
                this.address = {
                    address_line1 : null,
                    address_line2 : null,
                    address_line3 : null,
                    city: null,
                    state: null,
                    postal_code: null,
                    country: 'USA'
                };

                return;
            }

            this.address = _.cloneDeep(address);
        },

        onChange()
        {
            this.$emit('input',this.address);
        },
    },

    watch: {
        value(newValue, oldValue) {
            this.setAddress(newValue);
        },
    },
}
</script>

<style lang="scss" scoped>
.three_container
{
    display: flex;
    flex-direction: row;
}

.city
{
    margin-right: 15px;
    flex-grow: 5;
}

.state
{
    margin-right: 15px;
    flex-grow: 1;
}

.zip
{
    margin-right: 15px;
    flex-grow: 2;
}

</style>